import { UserApi } from "@/api/userApi";
import router from "@/router";
import { WardApi } from "../../app/wards/wardApi";

const state = {
  application_roles: [],
  application_languages: [],
  message_states: [],
  import_states: [],
  email_types: [],
  gender_types: [],
  ward_types: [],
  carrier_fees: [],
  contact_fields: [],
  search_operators: [],
  contact_types: [],
  appointment_states: [],
  appointment_types: [],
  ward_languages: [],
  ward_appointment_types: [],
  ward_appointment_intervals: [],
  phone_country_codes: [],
  ward_appointment_locations: [],
  ward_public_appointment_types: [],
  ward_public_appointment_days: [],
  ward_public_appointment_hours: {}
};

const getters = {};

const mutations = {
  loadRoles(state, payload) {
    state.application_roles = [];
    payload.forEach(x => {
      state.application_roles.push({
        value: x.permission,
        text: x.description
      });
    });
  },
  loadLanguages(state, payload) {
    state.application_languages = [];
    payload.forEach(x => {
      state.application_languages.push({
        value: x.language_code,
        text: x.description
      });
    });
  },
  loadCountryCodes(state, payload) {
    state.phone_country_codes = [];
    payload.forEach(x => {
      state.phone_country_codes.push({
        value: x.country_code,
        text: x.description
      });
    });
  },
  loadAppointmentStates(state, payload) {
    state.appointment_states = [];
    payload.forEach(x => {
      state.appointment_states.push({
        value: x.appointment_state,
        text: x.description
      });
    });
  },
  loadWardAppointmentTypes(state, payload) {
    state.ward_appointment_types = [];
    payload.forEach(x => {
      state.ward_appointment_types.push({
        value: x.appointment_type,
        text: x.description
      });
    });
  },
  loadAppointmentTypes(state, payload) {
    state.appointment_types = [];
    payload.forEach(x => {
      state.appointment_types.push({
        value: x.appointment_type,
        text: x.description
      });
    });
  },
  loadAppointmentIntervals(state, payload) {
    state.appointment_intervals = [];
    payload.forEach(x => {
      state.appointment_intervals.push({
        value: x.appointment_interval,
        text: x.description
      });
    });
  },
  loadMessageStates(state, payload) {
    state.message_states = [];
    payload.forEach(x => {
      state.message_states.push({
        value: x.message_state,
        text: x.description,
        disabled: x.disabled
      });
    });
  },
  loadImportStates(state, payload) {
    state.import_states = [];
    payload.forEach(x => {
      state.import_states.push({
        value: x.import_state,
        text: x.description,
        disabled: x.disabled
      });
    });
  },
  loadEmailTypes(state, payload) {
    state.email_types = [];
    payload.forEach(x => {
      state.email_types.push({
        value: x.email_type,
        text: x.description,
        disabled: x.disabled
      });
    });
  },
  loadGenderTypes(state, payload) {
    state.gender_types = [];
    //load default
    state.gender_types.push({
      value: null,
      text: "Select a gender",
      disabled: false
    });
    payload.forEach(x => {
      state.gender_types.push({
        value: x.gender_type,
        text: x.description,
        disabled: x.disabled
      });
    });
  },
  loadWardTypes(state, payload) {
    state.ward_types = [];
    //load default
    state.ward_types.push({
      value: null,
      text: "Select a ward type",
      disabled: false
    });
    payload.forEach(x => {
      state.ward_types.push({
        value: x.ward_type,
        text: x.description,
        disabled: x.disabled
      });
    });
  },
  loadCarrierFees(state, payload) {
    state.carrier_fees = [];
    state.carrier_fees.push({
      value: null,
      text: "Select a carrier Fee",
      disabled: false
    });
    payload.forEach(x => {
      state.carrier_fees.push({
        value: x.carrier_fee,
        text: x.description,
        disabled: false
      });
    });
  },
  loadContactFields(state, payload) {
    state.contact_fields = [];
    state.contact_fields.push({
      value: "all",
      text: "Search all fields",
      disabled: false
    });
    payload.forEach(x => {
      if (x.field_name == "all") return;
      state.contact_fields.push({
        value: x.field_name,
        text: x.description
      });
    });
  },
  loadSearchOperators(state, payload) {
    state.search_operators = [];
    payload.forEach(x => {
      state.search_operators.push({
        value: x.operator_name,
        text: x.description
      });
    });
  },
  loadContactTypes(state, payload) {
    state.contact_types = [];
    payload.forEach(x => {
      state.contact_types.push({
        value: x.contact_type,
        text: x.description
      });
    });
  },
  loadWardLanguages(state, payload) {
    state.ward_languages = [];
    payload.forEach(x => {
      state.ward_languages.push({
        value: x.language_code,
        text: x.description
      });
    });
  },
  loadWardAppointmentLocations(state, payload) {
    state.ward_appointment_locations = [];
    payload.forEach(x => {
      state.ward_appointment_locations.push({
        value: x.appointment_location,
        text: x.description
      });
    });
  },
  loadWardPublicAppointmentTypes(state, payload) {
    state.ward_public_appointment_types = [];
    payload.forEach(x => {
      state.ward_public_appointment_types.push({
        value: x.appointment_type,
        text: x.description
      });
    });
  },
  loadWardPublicAppointmentDays(state, payload) {
    state.ward_public_appointment_days = [];
    if (payload && Array.isArray(payload)) {
      payload.forEach(x => {
        state.ward_public_appointment_days.push(x);
      });
    }
  },
  loadWardPublicAppointmentHours(state, payload) {
    state.ward_public_appointment_hours = payload || {};
  }
};

const actions = {
  async loadRoles({ commit, state }) {
    //load everything fo the app, this doesn't change per ward/stake
    const { data } = await UserApi.getRoles();
    //console.log(data);
    commit("loadRoles", data.permissions);
    commit("loadLanguages", data.languages);
    commit("loadMessageStates", data.message_states);
    commit("loadImportStates", data.import_states);
    commit("loadEmailTypes", data.email_types);
    commit("loadGenderTypes", data.gender_types);
    commit("loadWardTypes", data.ward_types);
    commit("loadCarrierFees", data.carrier_fees);
    commit("loadContactFields", data.contact_fields);
    commit("loadSearchOperators", data.search_operators);
    commit("loadContactTypes", data.contact_types);
    commit("loadAppointmentStates", data.appointment_states);
    commit("loadAppointmentTypes", data.appointment_types);
    commit("loadAppointmentIntervals", data.appointment_intervals);
    commit("loadCountryCodes", data.country_codes);
    commit("loadWardAppointmentLocations", data.appointment_locations);
  },
  async loadWardLanguages({ commit, state }, wardId) {
    //fetch the ward languages, this changes as a user may switch between
    //wards
    const { data } = await WardApi.getWardFrontEndSettings(wardId);
    commit("loadWardLanguages", data.ward_languages);
    // Commit appointments_available to ward_appointment_types (for admin appointment forms)
    if (data.appointments_available) {
      commit("loadWardAppointmentTypes", data.appointments_available);
    }
    commit(
      "loadWardPublicAppointmentTypes",
      data.public_appointments_available
    );
    commit("loadWardPublicAppointmentDays", data.public_ward_appointment_days);
    commit("loadWardPublicAppointmentHours", data.public_appointment_hours);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};
